import React from "react";
import PropTypes from "prop-types";
import {Avatar, Drawer, List} from "@material-ui/core";
// import muiThemeable from "material-ui/styles/muiThemeable";
import {useTheme} from "@material-ui/core/styles"
import "./DrawerVault.css";

/**
 * Menu que se desplaza desde la derecha o la izquierda. Las opciones son recibidas como hijos.
 */
const DrawerVault = props => {
	const theme = useTheme()
	let { isOpen, username, onRequestChangeDrawer } = props;
	return (
		<Drawer
			docked={false}
			open={isOpen}
			width={300}
			openSecondary={props.isRight}
			onRequestChange={onRequestChangeDrawer}
		>
			<div
				style={{
					background:theme.drawer.header.background,
					display: "flex",
					alignItems: "center",
					padding: "25px 30px 25px 25px"
				}}
			>
				<Avatar size={50} src={props.avatarSrc} />
				<div className="infoUserContainer">
					<div className="mainText">{username}</div>
					<div className="secondText">{props.email}</div>
					<div className="secondText">{props.rol}</div>
				</div>
			</div>
			<List>
				{props.children}	
			</List>
		</Drawer>
	);
};

DrawerVault.propTypes = {
	/**
	 * Si es `true` el menu estara abierto
	 */
	isOpen: PropTypes.bool,
	username: PropTypes.string,
	/**
	 * Funcion callback que es disparada cuando se pide cambiar el estado "Abierto" del menu
	 */
	onRequestChangeDrawer: PropTypes.func,
	/**
	 * Si es `true` el menu se desplazara desde la derecha
	 */
	isRight: PropTypes.bool,
	/**
	 * Ruta de la imagen avatar
	 */
	avatarSrc: PropTypes.string,
	email: PropTypes.string,
	rol: PropTypes.string
};

export default DrawerVault;



// WEBPACK FOOTER //
// ./src/components/DrawerVault/DrawerVault.js